import React, { useState } from 'react';
import PageWrapper from '@/components/ui/PageWrapper';
import { motion, AnimatePresence } from 'framer-motion';

const categories = ['All', 'Paint Correction', 'Ceramic Coating', 'Interior', 'Luxury Details'];

const portfolio = [
  { id: 1, category: 'Paint Correction', img: 'https://images.unsplash.com/photo-1613978148487-6d5aa7644585?auto=format&fit=crop&q=80&w=800', title: 'Porsche 911 Swirl Removal' },
  { id: 2, category: 'Ceramic Coating', img: 'https://images.unsplash.com/photo-1552930294-6b595f4c2974?auto=format&fit=crop&q=80&w=800', title: 'BMW M4 Ceramic Coated' },
  { id: 3, category: 'Interior', img: 'https://images.unsplash.com/photo-1584978591559-8b58d6e5089f?auto=format&fit=crop&q=80&w=800', title: 'Mercedes S-Class Leather Reset' },
  { id: 4, category: 'Luxury Details', img: 'https://images.unsplash.com/photo-1618843479313-40f8afb4b4d8?auto=format&fit=crop&q=80&w=800', title: 'Audi RS6 Full Detail' },
  { id: 5, category: 'Paint Correction', img: 'https://images.unsplash.com/photo-1601362840469-51e4d8d58785?auto=format&fit=crop&q=80&w=800', title: 'Ferrari F8 Tributo Polish' },
  { id: 6, category: 'Ceramic Coating', img: 'https://images.unsplash.com/photo-1605559424843-9e4c228bf1c2?auto=format&fit=crop&q=80&w=800', title: 'Mercedes G-Wagon Protection' },
];

const Gallery = () => {
  const [activeFilter, setActiveFilter] = useState('All');

  const filteredItems = activeFilter === 'All' 
    ? portfolio 
    : portfolio.filter(item => item.category === activeFilter);

  return (
    <PageWrapper>
      <div className="py-24 bg-bgDark min-h-screen">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-10">
          <div className="text-center mb-16">
            <h1 className="text-5xl md:text-6xl font-heading font-bold mb-6">Our Work</h1>
            <p className="text-xl text-textMuted max-w-2xl mx-auto">
              Browse our portfolio of stunning vehicle transformations. Seeing is believing.
            </p>
          </div>

          {/* Filters */}
          <div className="flex flex-wrap justify-center gap-2 mb-12">
            {categories.map(cat => (
              <button
                key={cat}
                onClick={() => setActiveFilter(cat)}
                className={`px-5 py-2 rounded-full text-sm font-medium transition-all ${activeFilter === cat ? 'bg-accent text-black' : 'bg-primary border border-white/10 text-textLight hover:border-accent/50'}`}
              >
                {cat}
              </button>
            ))}
          </div>

          {/* Grid */}
          <motion.div layout className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            <AnimatePresence>
              {filteredItems.map(item => (
                <motion.div
                  key={item.id}
                  layout
                  initial={{ opacity: 0, scale: 0.9 }}
                  animate={{ opacity: 1, scale: 1 }}
                  exit={{ opacity: 0, scale: 0.9 }}
                  transition={{ duration: 0.3 }}
                  className="group relative aspect-square rounded-xl overflow-hidden bg-primary"
                >
                  <img src={item.img} alt={item.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col justify-end p-6">
                    <span className="text-accent text-xs font-bold uppercase tracking-wider mb-1">{item.category}</span>
                    <h3 className="text-xl font-heading font-bold text-white">{item.title}</h3>
                  </div>
                </motion.div>
              ))}
            </AnimatePresence>
          </motion.div>
        </div>
      </div>
    </PageWrapper>
  );
};

export default Gallery;